<div class="org-mobile-navigation-menu">
  <div class="org-mobile-navigation-menu__header">
    <img
      class="org-mobile-navigation-menu__header--logo"
      src="assets/icons/proquifa-logo-cyan.svg"
      alt="proquifa logo"
    />
    <button
      class="org-mobile-navigation-menu__header--icon"
      (click)="onCloseMenu()"
    >
      <ng-icon name="heroXMark" size="24"></ng-icon>
    </button>
  </div>
  <div class="org-mobile-navigation-menu__content catalog">
    <p class="text-body-medium">Catálogo</p>
      <atm-category-card
        (click)="onCloseMenu()"
        class="item"
        *ngFor="let category of categories"
        [category]="category"
      ></atm-category-card>
  </div>
  <div class="org-mobile-navigation-menu__content account"  *ngIf="isLogged$ | async">
    <hr>
    <div class="title">
      <span class="text-body-medium text-gray-green-900">Mi Cuenta</span>
    </div>
    <button (click)="goToOrders()" class="account-item text-body-medium no-decoration">
      <img src="assets/icons/menu-file.svg" alt="File icon">
      <span class="text-gray-green-900">Ver Cotizaciones</span>
    </button>
    <button class="account-item" (click)="logoutUser()">
      <ng-icon
        class="--icon"
        name="heroArrowUpTray"
        size="24"
        color="red"
        grade="270"
      ></ng-icon>
      <span class="text-body-medium text-red-600" id="close-session">Cerrar Sesión</span>
    </button>
  </div>
</div>
